;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useParams, useRouter } from 'next/navigation';
import { Input, Label, FormGroup } from 'reactstrap';
import queryString from 'query-string';
import { useSessionStorage } from 'usehooks-ts';
import { getI18nUtils } from '../i18n/i18n-utils';
import { Locale } from '../i18n/i18n-config';

const JobFacetSearch = ({ jobDomains, activeDomains, locations, activeLocations, divisions, activeDivisions, dictionary }) => {
  const params = useParams<{ locale: Locale }>();
  const { locale }: { locale?: Locale } = params || {};
  const { formatMessage } = getI18nUtils(dictionary);
  const { push } = useRouter();
  const [, setSessionJobFacetFilters] = useSessionStorage<Record<string, any> | string | null>('jobFacetFilters', null);

  const handleToggle = ({ target }) => {
    const { type } = target.dataset;

    const filters = {
      jobDomains: activeDomains,
      locations: activeLocations,
      divisions: activeDivisions,
    };

    switch (type) {
      case 'location':
        if (activeLocations.indexOf(target.value) === -1) filters.locations = [...activeLocations, target.value];
        else filters.locations = activeLocations.filter((l) => l !== target.value);
        break;
      case 'jobDomain':
        if (activeDomains.indexOf(target.value) === -1) filters.jobDomains = [...activeDomains, target.value];
        else filters.jobDomains = activeDomains.filter((d) => d !== target.value);
        break;
      case 'division':
        if (activeDivisions.indexOf(target.value) === -1) filters.divisions = [...activeDivisions, target.value];
        else filters.divisions = activeDivisions.filter((d) => d !== target.value);
        break;
      default:
        break;
    }

    const query = queryString.stringify(filters, { arrayFormat: 'separator' });
    setSessionJobFacetFilters(query);

    const href = query ? `/${locale}/jobs/?${query}` : `/${locale}/jobs`;

    push(href);
  };

  return (
    <aside className="p-4 mb-4 border">
      <div className="mb-4">
        <h3 className="mb-2 mt-2">{formatMessage({ id: 'jobs_job_domains' })}</h3>

        {jobDomains &&
          jobDomains
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .map((domain) => (
              <FormGroup check key={domain.name}>
                <Label check style={{ cursor: 'pointer' }} for={`check_${domain.name}`}>
                  <Input
                    data-type="jobDomain"
                    type="checkbox"
                    id={`check_${domain.name}`}
                    name={`check_${domain.name}`}
                    checked={activeDomains.indexOf(domain.name) > -1}
                    onChange={handleToggle}
                    value={domain.name}
                  />
                  {formatMessage({ id: domain.name })} ({domain.count})
                </Label>
              </FormGroup>
            ))}
      </div>
      <div className="mb-4">
        <h3 className="mb-2 mt-2">{formatMessage({ id: 'jobs_job_provinces' })}</h3>
        {locations &&
          locations
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .map((location) => (
              <FormGroup check key={`location-${location.id}`}>
                <Label style={{ cursor: 'pointer' }} for={`check_${location.name}`}>
                  <Input
                    type="checkbox"
                    data-type="location"
                    id={`check_${location.name}`}
                    name={`check_${location.name}`}
                    checked={activeLocations.indexOf(location.id) > -1}
                    onChange={handleToggle}
                    value={location.id}
                  />
                  {formatMessage({ id: location.name })} ({location.count})
                </Label>
              </FormGroup>
            ))}
      </div>
      {divisions && (
        <div className="mb-4">
          <h3 className="mb-2 mt-2">{formatMessage({ id: 'divisions' })}</h3>
          {divisions
            .sort((a, b) => (a.name < b.name ? -1 : 1))
            .map((division) => (
              <FormGroup check key={`division-${division.id}`}>
                <Label style={{ cursor: 'pointer' }} for={`check_${division.name}`}>
                  <Input
                    type="checkbox"
                    data-type="division"
                    id={`check_${division.name}`}
                    name={`check_${division.name}`}
                    checked={activeDivisions.indexOf(division.id) > -1}
                    onChange={handleToggle}
                    value={division.id}
                  />
                  {formatMessage({ id: division.name })} ({division.count})
                </Label>
              </FormGroup>
            ))}
        </div>
      )}
    </aside>
  );
};

export default JobFacetSearch;
